import { Roles } from "src/utils/Constants"

export const canSwitchComplex = rol =>
  ![Roles.superadmin, Roles.company].includes(rol)

export const needsComplexModules = rol =>
  [Roles.admin, Roles.supervisor].includes(rol)
